var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import { Backdrop, Popover, Typography } from '@mui/material';
import RffTextField from './RffTextField';
var RffPopoverTextField = function (props) {
    var _a = __read(React.useState(null), 2), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = __read(useState(false), 2), backdropOpen = _b[0], setBackdropOpen = _b[1];
    var handleClick = function (event) {
        setBackdropOpen(true);
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
        setBackdropOpen(false);
    };
    var popoverOpen = Boolean(anchorEl);
    var id = popoverOpen ? 'simple-popover' : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: function (e) {
                if (!props.popOverClickable)
                    handleClick(e);
            } },
            React.createElement(RffTextField, __assign({}, props, { className: "lfc-truncate lfc-cursor-pointer" }))),
        React.createElement(Backdrop, { open: backdropOpen, onClick: handleClose },
            React.createElement(Popover, { open: popoverOpen, anchorEl: anchorEl, id: id, anchorOrigin: {
                    vertical: 'center',
                    horizontal: 'left'
                }, BackdropProps: {
                    style: {
                        backgroundColor: 'rgba(0, 0, 0, 0.7)'
                    }
                } },
                React.createElement("div", { style: { width: '400px', padding: '12px', maxHeight: '200px', paddingBottom: '16px' } },
                    React.createElement(Typography, null, props.rffInput.value))))));
};
export default RffPopoverTextField;
//# sourceMappingURL=RffPopoverTextField.js.map